import userInfo from 'hub-http/userInfo';
import { gate } from 'hub-http/gates';
import { useEffect, useState } from 'react';
export const INBOUND_CARD_DESIGN_GATE = gate('Academy:ContentCard:InboundDesign');
export const useGate = targetGate => {
  var _userInfoData$gates$i;
  const [userInfoData, setUserInfoData] = useState();
  useEffect(() => {
    userInfo().then(data => setUserInfoData(data)).catch(error => {
      console.error(error);
    });
  }, []);
  return (_userInfoData$gates$i = userInfoData === null || userInfoData === void 0 ? void 0 : userInfoData.gates.includes(targetGate)) !== null && _userInfoData$gates$i !== void 0 ? _userInfoData$gates$i : false;
};